import { useEffect, useRef } from "react";

/** Section heading trio used everywhere: eyebrow / h2 / lede. */
export function Heading({ eyebrow, title, lede, id, center = false }) {
  return (
    <div id={id} style={{ marginBottom: 34, textAlign: center ? "center" : "left" }}>
      {eyebrow && <div className="eyebrow">{eyebrow}</div>}
      <h2 className="h2" style={center ? { marginLeft: "auto", marginRight: "auto" } : undefined}>{title}</h2>
      {lede && <p className="lede" style={center ? { marginLeft: "auto", marginRight: "auto" } : undefined}>{lede}</p>}
    </div>
  );
}

/** Fade-in on scroll (respects reduced motion via CSS). */
export function Reveal({ children, as: Tag = "div", className = "", ...rest }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current; if (!el) return;
    const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { el.classList.add("in"); io.disconnect(); } }), { threshold: 0.12 });
    io.observe(el); return () => io.disconnect();
  }, []);
  return <Tag ref={ref} className={`reveal ${className}`} {...rest}>{children}</Tag>;
}
